/**
 * Formats a number with Indian locale formatting
 */
export const formatNumber = (value?: number): string => {
  if (value === undefined || value === null || Number.isNaN(value)) {
    return '-';
  }
  return new Intl.NumberFormat('en-IN').format(Number(value));
};

/**
 * Formats currency in compact Indian notation (Cr / L)
 */
export const formatCompactIndianCurrency = (value?: number, symbol = '₹'): string => {
  if (value === undefined || value === null || Number.isNaN(value)) {
    return '-';
  }
  const num = Number(value);
  if (Math.abs(num) >= 1_00_00_000) {
    return `${symbol}${(num / 1_00_00_000).toFixed(1)} Cr`;
  }
  if (Math.abs(num) >= 1_00_000) {
    return `${symbol}${(num / 1_00_000).toFixed(1)}L`;
  }
  return `${symbol}${formatNumber(num)}`;
};

